import { render, staticRenderFns } from "./FaqCategories.vue?vue&type=template&id=12e79a46"
import script from "./FaqCategories.vue?vue&type=script&lang=ts"
export * from "./FaqCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports